<template>
  <div>
    <v-dialog
      v-model="dialog"
      :hide-overlay="!dialog"
      @click:outside.stop="dialog = false"
      @keydown.esc="dialog = false"
      persistent
      width="750"
      max-width="750px"
      :fullscreen="is_mobile"
      scrollable
      overlay-opacity="50"
      overlay-color="#ffffff"
      content-class="default-dialog"
    >
      <template v-slot:activator="{ on: dialog, attrs }">
        <div class="birthdays-btn_wrapper">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                v-bind="attrs"
                v-on="{ ...tooltip, ...dialog }"
                icon
                medium
                class="birthdays-btn_icon"
                :class="list.length < 1 ? 'none' : 'fill'"
              >
                <v-icon medium>mdi-cake-variant</v-icon>
              </v-btn>
            </template>
            <span>{{ lang.customers.birthdays.title }}</span>
          </v-tooltip>
          <div
            v-if="list.length > 0"
            class="birthdays-btn_counter"
          >
            {{ list.length }}
          </div>
        </div>
      </template>

      <v-card class="default-dialog-card">
        <v-card-title class="dialog-title">
          <span class="headline">
            <v-icon class="toolbar-icon customer-birthday_icon">mdi-cake-variant</v-icon>
            {{ lang.customers.birthdays.title }}
          </span>
          <v-spacer></v-spacer>
          <v-icon class="dialog-close-btn" @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="pa-2">
          <DataTable
            name="customers"
            :items="list"
            :tablehdrs="tableheaders.birthdays"
            sortby="date_diff"
            groupby="date_diff"
            :sortdesc="false"
          >
            <template v-slot:groupName="{ group }">
              {{ getBirthdayDate(group) }}
            </template>
            <template v-slot:default="{ item }">
              <tr
                :key="item.id"
                @dblclick="viewDialog(item)"
                class="table-row"
              >
                <td>
                  <strong>{{ item.id }}</strong>
                </td>
                <td>
                  {{ item.name }}
                  <v-tooltip
                    v-if="item.is_birthday"
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        class="customer-birthday_icon"
                        small
                      >
                        mdi-cake-variant
                      </v-icon>
                    </template>
                    <span>{{ lang.customers.birthdays.today_birthday }}</span>
                  </v-tooltip>
                </td>
                <td>
                  {{ item.phone | phoneMask }}
                </td>
                <td class="actionsCol">
                  <Actions :customer="item" />
                </td>
              </tr>
            </template>
          </DataTable>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Actions from './Actions'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

import moment from 'moment'

moment.locale('pt-br')

export default {
  components: { DataTable, Actions },
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    list () {
      let data = [ ...this.value ]

      data = data
        .filter(cst => {
          if (typeof cst.birth_date !== 'undefined' && cst.birth_date !== null) {
            let birth_date = moment.utc(cst.birth_date).year(moment().year()),
                today_date = moment(),
                date_diff = birth_date.diff(today_date, 'days', true)

            if (date_diff > -2 && date_diff <= 1) {
              return true
            }
          }
          return false
        })
        .map(cst => {
          let birth_date = moment.utc(cst.birth_date).year(moment().year()),
              today_date = moment(),
              date_diff = birth_date.diff(today_date, 'days', true)

          switch (true) {
            case date_diff < -1:
              date_diff = -1
              break;
            case date_diff <= 0:
              date_diff = 0
              break;
            case date_diff > 0:
              date_diff = 1
              break;
          }

          return {
            ...cst,
            date_diff 
          }
        })

      return data
    }
  },
  methods: {
    getBirthdayDate (date_diff) {
      switch (date_diff) {
        case -1:
          return this.lang.customers.birthdays.yesterday
        case 0:
          return this.lang.customers.birthdays.today
        case 1:
          return this.lang.customers.birthdays.tomorrow
        default:
          return date_diff
      }
    }
  }
}
</script>

<style lang="scss">
.birthdays-btn_wrapper {
  #app & {
    position: relative;
    .birthdays-btn_counter {
      position: absolute;
      top: 7px;
      right: 4px;
      background: #999;
      width: 15px;
      height: 15px;
      color: #fff;
      font-size: 10px;
      text-align: center;
      border-radius: 10px;
    }
    .birthdays-btn_icon {
      &.none .v-icon {
        color: #999;
      }
      &.fill .v-icon {
        background:-moz-linear-gradient(to top, #f36dd4, #ae6df3, #6d91f3, #b2f36d, #f3e86d, #f3ae6d, #f36d6f); 
        background: -webkit-linear-gradient(to top, #f36dd4, #ae6df3, #6d91f3, #b2f36d, #f3e86d, #f3ae6d, #f36d6f); 
        background: linear-gradient(to top, #f36dd4, #ae6df3, #6d91f3, #b2f36d, #f3e86d, #f3ae6d, #f36d6f);
        -webkit-background-clip: text;
        -moz-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
}
</style>

<style scoped src="../../styles/list.scss" lang="scss"></style>